import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { CheckCircle2, Phone } from 'lucide-react';
export function FullBathroomRemodelingPage() {
  return <div className="flex flex-col min-h-screen pt-24 pb-20" data-id="element-434">
      {/* Hero */}
      <section className="relative bg-gray-50 py-16 md:py-24 overflow-hidden" data-id="element-435">
        <div className="absolute inset-0 z-0" data-id="element-436">
          <img src="https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&q=80&w=2000" alt="Full bathroom remodeling" className="w-full h-full object-cover object-center" data-id="element-437" />
          <div className="absolute inset-0 bg-white/85" data-id="element-438"></div>
        </div>

        <div className="container relative z-10 mx-auto px-4 md:px-6" data-id="element-439">
          <div className="max-w-3xl mx-auto text-center" data-id="element-440">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-441">
              Full Bathroom Remodeling in Northern Indiana
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed mb-8" data-id="element-442">
              Transform your entire bathroom with comprehensive remodeling
              services from Lucky Duck Bathroom Company
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-443">
              <Link to="/contact" data-id="element-444">
                <Button size="lg" data-id="element-445">Get Free Consultation</Button>
              </Link>
              <Button variant="outline" size="lg" data-id="element-446">
                <Phone className="mr-2 h-5 w-5" data-id="element-447" />
                (574) 914-1522
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16" data-id="element-448">
        <div className="container mx-auto px-4 md:px-6 max-w-4xl" data-id="element-449">
          <div className="prose prose-lg max-w-none" data-id="element-450">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-451">
              Complete Bathroom Transformation Services
            </h2>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-452">
              A full bathroom remodel is more than just updating fixtures—it's
              about creating a space that perfectly fits your lifestyle,
              enhances your home's value, and provides years of comfort and
              functionality. At Lucky Duck Bathroom Company, we specialize in
              comprehensive bathroom renovations throughout Northern Indiana,
              delivering quality craftsmanship and stress-free project
              management from start to finish.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-453">
              What's Included in a Full Bathroom Remodel?
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-454">
              Our full bathroom remodeling service covers every aspect of your
              renovation project. We handle everything from initial design
              consultation through final installation, ensuring a seamless
              experience and exceptional results. Our comprehensive approach
              includes demolition of existing fixtures, plumbing and electrical
              updates, installation of new flooring, wall treatments, vanities,
              toilets, showers or tubs, lighting fixtures, and all finishing
              touches.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-455">
              We work with you to select materials that match your style
              preferences and budget, from classic designs to modern
              contemporary looks. Whether you're dreaming of a spa-like retreat
              with a luxurious soaking tub or a practical family bathroom with
              durable, easy-to-clean surfaces, we bring your vision to life with
              attention to every detail.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-456">
              Why Choose Lucky Duck for Your Bathroom Remodel?
            </h3>

            <div className="bg-gray-50 p-6 rounded-lg mb-6" data-id="element-457">
              <ul className="space-y-3" data-id="element-458">
                {['Expert design consultation to maximize your space and budget', 'Quality materials from trusted manufacturers', 'Skilled craftsmen with years of bathroom remodeling experience', 'Transparent pricing with no hidden fees or surprises', 'Clean, organized job sites with daily cleanup', 'Respect for your home and schedule', 'Warranty on workmanship and materials'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-459">
                    <CheckCircle2 className="h-6 w-6 text-[#8BA888] shrink-0 mt-0.5" data-id="element-460" />
                    <span className="text-gray-700" data-id="element-461">{item}</span>
                  </li>)}
              </ul>
            </div>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-462">
              Our Full Bathroom Remodeling Process
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-463">
              We believe in clear communication and careful planning. Your
              project begins with a free in-home consultation where we discuss
              your goals, take measurements, and provide honest recommendations.
              We'll walk you through material options, design possibilities, and
              provide a detailed estimate with no pressure to commit.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-464">
              Once you're ready to move forward, we create a project timeline
              and schedule that works around your life. Our team arrives on
              time, protects your home with proper coverings and barriers, and
              keeps you informed throughout every phase of construction. We
              handle all necessary permits and inspections, ensuring your
              remodel meets local building codes and safety standards.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8" data-id="element-465">
              Serving Northern Indiana Communities
            </h3>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-466">
              Lucky Duck Bathroom Company proudly serves homeowners throughout
              Northern Indiana, including South Bend, Mishawaka, Elkhart,
              Goshen, Granger, and surrounding communities. As a local,
              family-owned business, we understand the unique needs of Indiana
              homes and deliver remodeling solutions built to withstand our
              climate and lifestyle demands.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6" data-id="element-467">
              Whether you're updating a master bathroom, renovating a guest
              bath, or creating an accessible bathroom for aging in place, we
              have the expertise and dedication to exceed your expectations. Our
              reputation is built on quality work, honest pricing, and customer
              satisfaction—values we bring to every project, large or small.
            </p>

            <div className="bg-[#8BA888]/10 border-l-4 border-[#8BA888] p-6 rounded-r-lg mt-8" data-id="element-468">
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-469">
                Ready to Transform Your Bathroom?
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-470">
                Schedule your free consultation today and discover why
                homeowners across Northern Indiana trust Lucky Duck Bathroom
                Company for their remodeling needs.
              </p>
              <Link to="/contact" data-id="element-471">
                <Button size="lg" data-id="element-472">Request Free Consultation</Button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}